var map = {
	"./Amazon-clone.png": 1947,
	"./Brand.png": 5060,
	"./Daily ui.png": 9416,
	"./Dev.png": 6622,
	"./Digital painting.png": 5503,
	"./Dna.png": 1660,
	"./Ecom.png": 8895,
	"./Fontography.png": 524,
	"./Gif.png": 8777,
	"./Icon.png": 4896,
	"./Illustration.png": 8457,
	"./Infographics.png": 6400,
	"./Isometric.png": 6232,
	"./Learner.png": 2360,
	"./Local shop.png": 1356,
	"./Logo.png": 142,
	"./Photo manipulation.png": 4068,
	"./Smudge painting.png": 6862
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5360;